
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Investment } from "@/types/investment";

interface PortfolioSummaryProps {
  investments: Investment[];
}

const PortfolioSummary = ({ investments }: PortfolioSummaryProps) => {
  const availableOpportunities = investments.filter(inv => inv.status === "Open for Bidding").length;
  const totalPortfolioValue = investments.reduce((sum, inv) => sum + inv.currentBalance, 0);
  const avgYield = investments.reduce((sum, inv) => sum + inv.yield, 0) / investments.length;
  const avgITV = investments.reduce((sum, inv) => sum + inv.ltv, 0) / investments.length;

  return (
    <div className="grid md:grid-cols-4 gap-6 mb-8">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-lg">Available Opportunities</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-blue-600">
            {availableOpportunities}
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-lg">Total Portfolio Value</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-green-600">
            ${totalPortfolioValue.toLocaleString()}
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-lg">Avg. Yield</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-yellow-800">
            {avgYield.toFixed(1)}%
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-lg">Avg. ITV</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-purple-600">
            {avgITV.toFixed(0)}%
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PortfolioSummary;
